import React from 'react'
import { useTranslation } from 'react-i18next'

import ChecklistsFilterV2 from '../../../../containers/checklists/filters/ChecklistsFilterV2'
import FullPlacesFilterV2 from '../../../../containers/places/filters/FullPlacesFilterV2'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'
import UsersFilterV2 from '../../../../containers/users/filters/UsersFilterV2'

const FiltersBar = ({ open }) => {
  const { t } = useTranslation('places')

  return (
    <ScreenViewFilterBar screen="dashboard" open={open} lineOnTop ignoreFields={['date']}>
      <ChecklistsFilterV2 />
      <UsersFilterV2 />
      <FullPlacesFilterV2 label={t('filters.place')} field="placeIds" placeLevelField="placeLevelIds" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
